import React from 'react'

import PropTypes from 'prop-types'
import { BigTitle, RegularText } from 'Components/atoms'

import { NoResultsContainer, NoResultsBox, SearchIcon } from './styled'

const NoSearch = ({ title, description, fullWidth }) => (
  <NoResultsContainer fullWidth={fullWidth}>
    <NoResultsBox fullWidth={fullWidth}>
      <BigTitle margin='0 0 16px'>{title}</BigTitle>
      <RegularText>{description}</RegularText>
      <SearchIcon fullWidth={fullWidth} />
    </NoResultsBox>
  </NoResultsContainer>
)

NoSearch.defaultProps = {
  title: '',
  description: '',
  fullWidth: false,
}

NoSearch.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  fullWidth: PropTypes.bool,
}

export default NoSearch
